module.exports = __webpack_public_path__ + "img/undo.c6d9f752.svg";